import HealthWidget from '@components/MainWidget/Health/healthSeoWidget'
import TravelWidget from '@components/MainWidget/Travel/TravelMainSeoWidget'
import TravelSemWidget from '@components/MainWidget/Travel/Sem/TravelMainSemWidget'
import LifeWidget from '@components/MainWidget/LifeWidget/LifeWidget'
import CarWidget from '@components/MainWidget/Car/carWidget'
import BikeWidget from '@components/MainWidget/Bike/bikeWidget'
import FastagWidget from '@components/MainWidget/FastagWidget/fastagWidget'
import PucWidget from '@components/MainWidget/Puc/pucWidget'
import AbhaWidget from '@components/MainWidget/Abha/abhaWidget'
import MultiProductWidget from '@components/MainWidget/CarBikeInTab/MultiProductWidget'
import DynamicCta from '@components/MainWidget/CtaWidgetPurpleVariant/DynamicCta'
import RtoVehicleInfo from '@components/MainWidget/RtoVehicleInfo/rtoVehicleInfoWidget'
import RtoDetail from '@components/MainWidget/RtoDetail/rtoDetailWidget'
import ChallanWidget from '@components/MainWidget/ChallanWidget/challanWidget'
import ChallanWidgetLanding from '@components/MainWidget/ChallanWidgetLanding/ChallanWidgetLanding'
import FastagWidgetLanding from '@components/MainWidget/FastagWidgetLanding/fastagWidgetLanding'
import {
  ABHA_SEO_WIDGET,
  CHALLAN_WIDGET_LANDING,
  FASTAG_WIDGET_LANDING,
  HSRP_WIDGET_LANDING,
} from '@components/Product/ProductWidget/constants'
import { Visibility } from '@enums/Visibility'
import { isVasWidget } from '@helpers/vasLandingPageHelper'
import HsrpWidgetLanding from '@components/MainWidget/HsrpWidgetLanding/hsrpWidgetLanding'

export const DISABLE_USPS = ['car-seo-widget', 'bike-seo-widget']

export const PRODUCT_WIDGETS_VS_COMPONENTS = {
  'travel-seo-widget': TravelWidget,
  'health-seo-widget': HealthWidget,
  'life-seo-widget': LifeWidget,
  'travel-sem-widget': TravelSemWidget,
  'car-seo-widget': CarWidget,
  'bike-seo-widget': BikeWidget,
  'fastag-widget': FastagWidget,
  'puc-widget': PucWidget,
  'abha-seo-widget': AbhaWidget,
  'multi-product-widget': MultiProductWidget,
  'gmc-cta-widget': DynamicCta,
  'health-cta-widget': DynamicCta,
  'travel-cta-widget': DynamicCta,
  'life-cta-widget': DynamicCta,
  'rto-vehicle-info-widget': RtoVehicleInfo,
  'rto-widget': RtoDetail,
  'challan-widget': ChallanWidget,
  'challan-widget-landing-page': ChallanWidgetLanding,
  'fastag-widget-landing-page': FastagWidgetLanding,
  'hsrp-widget-landing-page': HsrpWidgetLanding,
}

export const NON_RESPONSIVE_WIDGET = ['health-seo-widget', 'life-seo-widget']
export const RESPONSIVE_WIDGET = [
  'travel-seo-widget',
  'travel-sem-widget',
  'car-seo-widget',
  'bike-seo-widget',
  'fastag-widget',
  'puc-widget',
  'abha-seo-widget',
  'multi-product-widget',
  'gmc-cta-widget',
  'health-cta-widget',
  'travel-cta-widget',
  'life-cta-widget',
  'rto-vehicle-info-widget',
  'rto-widget',
  'challan-widget',
  'challan-widget-landing-page',
  'fastag-widget-landing-page',
  'hsrp-widget-landing-page',
]

export const PRODUCT_WIDGETS_VS_BOTTOM_FLOATER_PROPS = ({ setShow }) => ({
  'travel-seo-widget': {
    isBottomFloater: true,
  },
  'travel-sem-widget': {
    isBottomFloater: true,
    showPhoneInput: false,
  },
  'health-seo-widget': {
    onHide: setShow,
    isBottomFloater: true,
    addScroll: true,
  },
  'life-seo-widget': {
    onHide: setShow,
    isBottomFloater: true,
    addScroll: true,
  },
  'car-seo-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'bike-seo-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'fastag-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'abha-seo-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'multi-product-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'gmc-cta-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'health-cta-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'travel-cta-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'life-cta-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'puc-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'rto-vehicle-info-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'rto-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'challan-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'challan-widget-landing-page': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'fastag-widget-landing-page': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'hsrp-widget-landing-page': {
    onHide: setShow,
    isBottomFloater: true,
  },
})

export const REALTION_VS_RELATION_PROPS = ({ productGoogleRatingResponse }) => ({
  'relation.product-page-grw': productGoogleRatingResponse,
})

export const widgetsProductType = {
  'travel-seo-widget': 'Travel',
  'travel-sem-widget': 'Travel',
  'health-seo-widget': 'Health',
  'life-seo-widget': 'Life',
  'car-seo-widget': 'Car',
  'bike-seo-widget': 'Bike',
  'fastag-widget': 'Fastag',
  'puc-widget': 'puc',
  'abha-seo-widget': 'abha',
  'gmc-cta-widget': 'Gmc CTA',
  'health-cta-widget': 'Health CTA',
  'travel-cta-widget': 'Travel CTA',
  'life-cta-widget': 'Life CTA',
  'rto-vehicle-info-widget': 'rto vehicle info',
  'rto-widget': 'rto detail',
  'challan-widget': 'challan widget',
  'challan-widget-landing-page': 'challan landing widget',
  'fastag-widget-landing-page': 'fastag landing widget',
  'hsrp-widget-landing-page': 'hsrp landing widget',
}

export const RELATION_VS_COMPONENT_DATA = {
  'relation.product-page-author': content => content?.[0]?.attributes?.authorName?.data,
}

export const getAutoWidgetLayout = {
  'travel-seo-widget': false,
  'travel-sem-widget': false,
  'health-seo-widget': false,
  'life-seo-widget': false,
  'car-seo-widget': true,
  'bike-seo-widget': true,
  'fastag-widget': true,
  'abha-seo-widget': false,
  'multi-product-widget': true,
  'gmc-cta-widget': false,
  'health-cta-widget': false,
  'travel-cta-widget': false,
  'life-cta-widget': false,
  'puc-widget': true,
  'rto-vehicle-info-widget': true,
  'rto-widget': true,
  'challan-widget': true,
  'challan-widget-landing-page': true,
  'fastag-widget-landing-page': true,
  'hsrp-widget-landing-page': true,
}

export const getpurpleRootContainerLayout = {
  'travel-seo-widget': false,
  'travel-sem-widget': false,
  'health-seo-widget': false,
  'life-seo-widget': false,
  'car-seo-widget': true,
  'bike-seo-widget': true,
  'fastag-widget': true,
  'puc-widget': true,
  'abha-seo-widget': true,
  'multi-product-widget': true,
  'gmc-cta-widget': true,
  'health-cta-widget': true,
  'travel-cta-widget': true,
  'life-cta-widget': true,
  'rto-vehicle-info-widget': true,
  'rto-widget': true,
  'challan-widget': true,
  'challan-widget-landing-page': true,
  'fastag-widget-landing-page': true,
  'hsrp-widget-landing-page': true,
}

export const getHealthWidgetLayout = {
  'health-seo-widget': false,
  'abha-seo-widget': true,
  'multi-product-widget': false,
  'gmc-cta-widget': false,
  'health-cta-widget': false,
  'travel-cta-widget': false,
  'life-cta-widget': false,
}

export const getCtaWidgetPurpleLayout = {
  'abha-seo-widget': false,
  'gmc-cta-widget': true,
  'health-cta-widget': true,
  'travel-cta-widget': true,
  'life-cta-widget': true,
  'travel-seo-widget': false,
  'travel-sem-widget': false,
  'health-seo-widget': false,
  'life-seo-widget': false,
  'car-seo-widget': false,
  'bike-seo-widget': false,
  'fastag-widget': false,
  'puc-widget': false,
  'multi-product-widget': false,
  'rto-vehicle-info-widget': false,
  'rto-widget': false,
  'challan-widget': false,
}

export const replaceDivWithHeadingTags = {
  'fastag-widget': true,
  'multi-product-widget': true,
  'puc-widget': true,
  'rto-vehicle-info-widget': true,
  'rto-widget': true,
  'challan-widget': true,
  'challan-widget-landing-page': true,
  'fastag-widget-landing-page': true,
  'hsrp-widget-landing-page': true,
}

export const shouldHideHeader = {
  'fastag-widget-landing-page': true,
  'hsrp-widget-landing-page': true,
}

export const HEADING_TAGS = {
  SEO_CAR_WIDGET: 'h1',
  HEALTH_WIDGET_PURPLE_LAYOUT: 'h1',
  DEFAULT: 'h2',
}

export const ContainerVisibility = {
  [Visibility.SHOW]: true,
  [Visibility.HIDE]: false,
}

export const widgetVisibilityConfig = {
  [ABHA_SEO_WIDGET]: ContainerVisibility,
  [CHALLAN_WIDGET_LANDING]: ContainerVisibility,
  [FASTAG_WIDGET_LANDING]: ContainerVisibility,
  [HSRP_WIDGET_LANDING]: ContainerVisibility,
}

export const shouldDisplayWidget = (widgetType, isRightContainer) => {
  const isAbhaWidget = widgetType === ABHA_SEO_WIDGET
  const isVasLandingWidget = isVasWidget(widgetType)
  if (isVasLandingWidget) {
    return widgetVisibilityConfig[widgetType][isRightContainer ? Visibility.SHOW : Visibility.HIDE]
  }

  return isAbhaWidget
    ? widgetVisibilityConfig[ABHA_SEO_WIDGET][isRightContainer ? Visibility.SHOW : Visibility.HIDE]
    : !isRightContainer
}
